import Link from "next/link";

import { routes } from "src/shared/routes";
import { createJsxLink } from "src/utils/create-jsx-link";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer:
      "Once you purchase your Buckeyes Flex Pass you are eligible for a ticket per pass for all games on the schedule.",
  },
  {
    question: "Do I get a ticket to each game on the schedule?",
    answer:
      "Tickets are guaranteed for the games defined in the pass. There are no penalties for not attending a game. You can review your schedule on your homepage.",
  },
  {
    question: "How do I access my tickets?",
    answer:
      "You will receive a text message a few hours before the game with a link to your tickets with your seat location.",
  },
  {
    question: "How are tickets sent to me?",
    answer: (
      <>
        You will receive a text message 9:00 AM on game day with a link on how
        to access your tickets via your{" "}
        <Link href="https://am.ticketmaster.com/buckeyes/" target="_blank">
          Buckeyes Account Manager
        </Link>
        .
      </>
    ),
  },
  {
    question: "Where will my seats be located?",
    answer: "Seat location may vary game by game.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Flex Pass tickets & guest passes, are not eligible for resale or transfer. Abusing these guidelines may result in your Flex Pass being revoked.",
  },
  {
    question: "Can my seats be changed?",
    answer: (
      <>
        Once tickets have been sent to your account, they cannot be changed.
        Please contact{" "}
        <Link href="mailto:athletic.tix@osu.edu">athletic.tix@osu.edu</Link> for
        any assistance you may require.
      </>
    ),
  },
  {
    question: "Can I link tickets with other pass holders?",
    answer: (
      <>
        Yes, you can create a group to link with other pass holders! Navigate to
        the{" "}
        <Link
          href={{
            pathname: routes.my_group,
            query: { teamSchema: "buckeyes_flex" },
          }}
        >
          My Group
        </Link>{" "}
        tab in your menu and copy the invite. This will ensure you are seated
        together for the game. You will need to ensure your group is created and
        all members have joined at least 4 hours prior to game start in order to
        be seated with one another.
      </>
    ),
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "Guest tickets will be available for select games. If available, you will receive a text message & email letting you know they are in sale.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer:
      "No, we do not issue any refunds for games you are not able to attend. Passes are non-transferable and non-refundable.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By checking this box you agree to the{" "}
    {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")} and{" "}
    {createJsxLink("Privacy Policy", "https://www.attend.tech/privacy-policy")}.
  </>
);

export const REGISTRATION_TERMS_AND_CONDITIONS = () => (
  <>
    By checking this box you agree to receive notifications regarding offers and
    ticket delivery and agree to the{" "}
    {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")} and{" "}
    {createJsxLink("Privacy Policy", "https://www.attend.tech/privacy-policy")}.
  </>
);

export const PASS_PURCHASE_SUCCESS_MESSAGE: TTeamConfig["LANGUAGES"]["PASS_PURCHASE_SUCCESS_MESSAGE"] =
  {
    TITLE: () => <>You&apos;re all set to experience the action!</>,
    DESCRIPTION: () => {
      const router = useRouterExt();
      return (
        <>
          Invite your friends! Create groups{" "}
          <b>
            <u>
              <span
                onClick={() => router.pushSchema(routes.my_group)}
                style={{ cursor: "pointer" }}
              >
                here
              </span>
            </u>
          </b>
          .
        </>
      );
    },
  };
